module.exports = __webpack_public_path__ + "static/background-image-modal-movil-2732c37b3340f8d439b33f9e446178e2.webp";